import styled from 'styled-components';

export const SButtonWrapper = styled.div`
  > * {
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
`;
